import cx from 'classnames';
import React from 'react';

import * as styles from './styles.css';
import Box, { BoxProps } from '../Box';

const Footer: React.FC<BoxProps> = ({ className, ...rest }) => {
  return <Box element="div" className={cx(styles['footer'], className)} {...rest} />;
};

export default Footer;
